import apiService from '../utils/apiService';

import {
  UPDATE_KJS,
  UPDATE_KJS_START,
  UPDATE_KJS_ERROR,
  GET_KJS_LIST_START,
  GET_KJS_LIST,
  GET_KJS_LIST_ERROR,
  GET_KJS_LIST_BY_INSTITUTION_TYPE,
  GET_KJS_LIST_BY_INSTITUTION_TYPE_START,
  GET_KJS_LIST_BY_INSTITUTION_TYPE_ERROR,
  GET_KJS_LIST_BY_MUNICIPALITY,
  GET_KJS_LIST_BY_MUNICIPALITY_START,
  GET_KJS_LIST_BY_MUNICIPALITY_ERROR,
  GET_KJS_LIST_PAGEBALE,
  GET_KJS_LIST_PAGEBALE_START,
  GET_KJS_LIST_PAGEBALE_ERROR,
  GET_KJS_FILTER_LIST,
  GET_KJS_FILTER_LIST_START,
  GET_KJS_FILTER_LIST_ERROR,
  CLEAR_KJS_LIST,
} from './types';

import {
  kjsFindAllPath,
  kjsFindAllByInstitutionTypePath,
  kjsFindAllPageablePath,
  filterPageablePath,
  kjsFindAllByMunicipalityIdPath,
  kjsUpdatePath,
} from '../constants/apiEndpoints';

import {
  notificationTypeError,
  notificationTypeSuccess,
} from '../constants/globals';

import { createNotification } from '../utils';

const clearList = () => {
  return {
    type: CLEAR_KJS_LIST,
  };
};

const getKjsListStart = () => {
  return {
    type: GET_KJS_LIST_START,
  };
};
const getKjsListSuccessfully = (data) => {
  return {
    type: GET_KJS_LIST,
    payload: data,
  };
};
const getKjsListUnsuccessfully = (err) => {
  return {
    type: GET_KJS_LIST_ERROR,
    payload: err,
  };
};

const getKjsListPageableStart = () => {
  return {
    type: GET_KJS_LIST_PAGEBALE_START,
  };
};
const getKjsListPageableSuccessfully = (data, pageNumber, totalElements) => {
  return {
    type: GET_KJS_LIST_PAGEBALE,
    payload: [data, pageNumber, totalElements],
  };
};
const getKjsListPageableUnsuccessfully = (err) => {
  return {
    type: GET_KJS_LIST_PAGEBALE_ERROR,
    payload: err,
  };
};

const getKjsListByInstitutionTypeStart = () => {
  return {
    type: GET_KJS_LIST_BY_INSTITUTION_TYPE_START,
  };
};
const getKjsListByInstitutionTypeSuccessfully = (data) => {
  return {
    type: GET_KJS_LIST_BY_INSTITUTION_TYPE,
    payload: data,
  };
};
const getKjsListByInstitutionTypeUnsuccessfully = (err) => {
  return {
    type: GET_KJS_LIST_BY_INSTITUTION_TYPE_ERROR,
    payload: err,
  };
};

const getKjsListByMunicipalityStart = () => {
  return {
    type: GET_KJS_LIST_BY_MUNICIPALITY_START,
  };
};

const updateKjsSuccessfully = (data) => {
  return {
    type: UPDATE_KJS,
    payload: data,
  };
};

const updateKjsUnsuccessfully = (err) => {
  return {
    type: UPDATE_KJS_ERROR,
    payload: err,
  };
};

const updateKjsStart = () => {
  return {
    type: UPDATE_KJS_START,
  };
};

const getKjsListByMunicipalitySuccessfully = (data) => {
  return {
    type: GET_KJS_LIST_BY_MUNICIPALITY,
    payload: data,
  };
};

const getKjsListByMunicipalityUnsuccessfully = (err) => {
  return {
    type: GET_KJS_LIST_BY_MUNICIPALITY_ERROR,
    payload: err,
  };
};

const getKjsFilterListStart = () => {
  return {
    type: GET_KJS_FILTER_LIST_START,
  };
};
const getKjsFilterListSuccessfully = (data, pageNumber, totalElements) => {
  return {
    type: GET_KJS_FILTER_LIST,
    payload: [data, pageNumber, totalElements],
  };
};
const getKjsFilterListUnsuccessfully = (err) => {
  return {
    type: GET_KJS_FILTER_LIST_ERROR,
    payload: err,
  };
};

export const findAllKjs = () => {
  return (dispatch) => {
    dispatch(getKjsListStart());
    return apiService
      .get(kjsFindAllPath())
      .then((response) => {
        dispatch(getKjsListSuccessfully(response.data));
      })
      .catch((err) => {
        dispatch(getKjsListUnsuccessfully(err?.response?.data));
      });
  };
};

export const findAllKjsPageable = (pageNumber, pageSize) => {
  return (dispatch) => {
    dispatch(getKjsListPageableStart());
    return apiService
      .get(kjsFindAllPageablePath(pageNumber, pageSize))
      .then((response) => {
        dispatch(
          getKjsListPageableSuccessfully(
            response.data.content,
            response.data.totalPages,
            response.data.totalElements
          )
        );
      })
      .catch((err) => {
        dispatch(getKjsListPageableUnsuccessfully(err?.response?.data));
      });
  };
};

export const findAllKjsByInstitutionType = (institutionTypeId) => {
  return (dispatch) => {
    dispatch(getKjsListByInstitutionTypeStart());
    return apiService
      .get(kjsFindAllByInstitutionTypePath(institutionTypeId))
      .then((response) => {
        dispatch(getKjsListByInstitutionTypeSuccessfully(response.data));
      })
      .catch((err) => {
        dispatch(
          getKjsListByInstitutionTypeUnsuccessfully(err?.response?.data)
        );
      });
  };
};

export const findAllKjsByMunicipality = (municipalityId) => {
  return (dispatch) => {
    dispatch(getKjsListByMunicipalityStart());
    return apiService
      .get(kjsFindAllByMunicipalityIdPath(municipalityId))
      .then((response) => {
        dispatch(getKjsListByMunicipalitySuccessfully(response.data));
      })
      .catch((err) => {
        dispatch(getKjsListByMunicipalityUnsuccessfully(err?.response?.data));
      });
  };
};

export const updateKjs = (
  kjs,
  callback,
  messages,
  callback2,
  signalActivation
) => {
  return (dispatch) => {
    dispatch(updateKjsStart());
    const signal = signalActivation ? true : false;
    return apiService
      .post(kjsUpdatePath(signal), kjs)
      .then((response) => {
        dispatch(updateKjsSuccessfully(response.data));
        callback();
        callback2();
        createNotification(
          notificationTypeSuccess,
          messages.kjs,
          messages.message
        );
      })
      .catch((err) => {
        dispatch(updateKjsUnsuccessfully(err?.response?.data));
        createNotification(
          notificationTypeError,
          messages.kjs,
          err?.response?.data?.message
        );
      });
  };
};

export const findAllKjsFilterPageable = (
  pageNumber,
  pageSize,
  data,
  succesCallback
) => {
  return (dispatch) => {
    dispatch(getKjsFilterListStart());
    return apiService
      .post(filterPageablePath(pageNumber, pageSize), data)
      .then((response) => {
        dispatch(
          getKjsFilterListSuccessfully(
            response.data.content,
            response.data.totalPages,
            response.data.totalElements
          )
        );
        succesCallback();
      })
      .catch((err) => {
        dispatch(getKjsFilterListUnsuccessfully(err?.response?.data));
      });
  };
};

export const clearKjsList = () => {
  return (dispatch) => {
    dispatch(clearList());
  };
};
